<script src="../tekst-persoonlijk-aangever/tekst-persoonlijk-aangever.component.spec.ts"></script>
<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Loon tegenwoordige arbeid
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <b>Welke inkomsten vallen onder loon uit tegenwoordige arbeid?</b><br/>
                <li class="list">loon van de werkgever</li>
                <li class="list">loon dat wordt doorbetaald door het UWV (bijvoorbeeld omdat de werkgever failliet is
                    gegaan)
                </li>
                <li class="list">fooien, en andere inkomsten uit loondienst die niet onder de loonheffing vallen</li>
                <li class="list">stagevergoedingen (als deze geen onkostenvergoedingen zijn)</li>
                <li class="list">loon bij een aanmerkelijk belang (directeur-grootaandeelhouder)</li>
                <li class="list">te veel ontvangen loon</li>
                <li class="list">uitkeringen op grond van de Wet arbeid en zorg (WAZO), bijvoorbeeld zwangerschaps-,
                    bevallings- en
                    calamiteitenverlof, uitkeringen voor de financiering loopbaanonderbreking, en de eventuele
                    aanvullingen hierop. Als deze uitkeringen niet door je werkgever zijn uitbetaald maar door het UWV,
                    dan vallen ze onder 'Pensioen en andere uitkeringen'
                </li>
                <li class="list">een militair in actieve dienst en uitgezonden naar het buitenland.</li>

                <div class="space10"></div>

                <b>Welke inkomsten vul je hier niet in?</b><br/>
                <li class="list">kies 'Buitenlands loon' als er buiten Nederland gewerkt is, ook al was dit voor een
                    Nederlandse
                    werkgever.
                </li>
                <li class="list">kies 'Vrijgesteld loon' als het gaat om inkomsten als (oud-)werknemer bij een
                    internationale
                    organisatie. De persoon werkte bijvoorbeeld bij de Europese Unie, de Verenigde Naties of de NAVO. In
                    Nederland hoef je dan geen belasting te betalen over deze inkomsten, maar je moet deze wel aangeven.
                    Dit geldt ook voor een Nederlands ambtenaar en in dienst van Justitie op Curaçao? Kies dan ook
                    'Vrijgesteld loon van een internationale volkenrechtelijke organisatie'.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Loon terugbetaald
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als je loon ontvangt, betaalt je over die inkomsten belasting. Kreeg je te veel loon? Of kreeg je ten
                onrechte loon? En moet je dit terugbetalen?
                Terugbetaling van deze te veel of ten onrechte ontvangen inkomsten noemen wij 'negatief loon'. Misschien
                krijg je de belasting terug die over de terugbetaalde inkomsten is ingehouden.
                <div class="space10"></div>

                De werkgever kan de terugbetaling op verschillende manieren verrekenen. Van
                belang is bijvoorbeeld of je het netto- of brutobedrag hebt terugbetaald. Vraag bij de werkgever na hoe
                de terugbetaling is verrekend.
                <div class="space10"></div>

                <b>Er zijn 2 manieren:</b><br/>
                <li class="list">de werkgever verrekende de terugbetaalde inkomsten met het brutoloon. In dat geval hoef
                    je niets te doen. Dit is verwerkt in de jaaropgaaf.
                </li>
                <li class="list">je betaalde (een deel van) de te veel of ten onrechte ontvangen inkomsten zelf terug
                    in {{ this.year }}. Dan kun je de belasting hierover terugvragen via de aangifte. Vermeld dat bedrag
                    bij 'Inkomsten uit
                    loondienst'. Zet een minteken voor dit bedrag
                </li>
                <div class="space10"></div>

                <b>Uitzonderingen</b><br/>
                Misschien hoef je de te veel of ten onrechte ontvangen inkomsten niet aan te geven. Daarvoor moet het
                voldoen aan de volgende voorwaarden:
                <li class="list">de persoon kreeg het loon niet te kwader trouw.</li>
                <li class="list">de persoon kan aantonen dat hij de te veel of ten onrechte ontvangen inkomsten helemaal
                    hebt
                    terugbetaald.
                </li>
                <li class="list">de persoon heeft de terugbetaling van de ten onrechte ontvangen inkomsten
                    in {{ this.year }} niet
                    afgetrokken van het loon. Of hij heeft dat wel gedaan en gaat akkoord met het corrigeren van die
                    aftrek. Gaat het om in eerste instantie terecht ontvangen looninkomsten die worden vervangen door
                    andere looninkomsten? Bijvoorbeeld een bijstandsuitkering die met terugwerkende kracht wordt
                    vervangen door een Ziektewetuitkering? Dan mag je de terugbetaling als negatief loon aangeven in het
                    jaar waarin het loon of de uitkering ontving is. Je moet dan wel voldoen aan de volgende
                    voorwaarden:<br/>
                    - de persoon kreeg het loon niet te kwader trouw<br/>
                    - de persoon kan aantonen dat hij de teveel of ten onrechte ontvangen inkomsten helemaal heeft
                    terugbetaald.
                </li>
                <li class="list">de persoon betaalt het loon terug voor 1 april van het jaar nadat hij deze inkomsten
                    had. Of hij geeft voor deze datum door dat hij deze inkomsten later in dat jaar terugbetaalt.
                </li>
                <li class="list">de persoon gaat akkoord met het terugnemen van de aftrek als hij in een ander jaar de
                    terugbetaalde
                    inkomsten heeft afgetrokken.
                </li>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Loon of uitkering terugbetaaldInkomsten waarover je werkgever geen loonheffing hoeft in te houden
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Over loon betaalt de werknemer belasting en premie volksverzekeringen: de loonheffing. De werkgever
                houdt deze
                loonheffing al voor hem in. Maar niet over alle inkomsten uit loondienst wordt loonheffing ingehouden.
                <div class="space10"></div>

                <b>Fooien</b><br/>
                Krijgt de werknemer fooien terwijl hij in loondienst bent? Vul dan het werkelijke bedrag aan fooien in,
                min het bedrag dat in de loonstrookjes wordt verwerkt. Informeer bij de werkgever welk bedrag in de
                loonstrookjes wordt verwerkt.
                <div class="space10"></div>

                <b> Andere inkomsten waarover je werkgever geen loonheffing hoeft in te houden</b><br/>
                Krijgt de werknemer voordelen van anderen dan de werkgever terwijl bij in loondienst is? Geef het
                werkelijke bedrag aan van die andere inkomsten, min het bedrag dat al in de loonstrookjes wordt
                verwerkt, bijvoorbeeld bij fooien. Informeer bij de werkgever welk bedrag in de loonstrookjes wordt
                verwerkt.

            </div>
        </div>
    </div>

</div>



